export default __webpack_public_path__ + "static/media/44.d2eb2e11.png";